import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SummaryApi from '../common/SummaryApi';
import Logo from "../assets/images/Logo.png";

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!email) {
      setError('Email is required');
      return;
    }

    setLoading(true);
    
    try {
      await axios.post(SummaryApi.sendResetLink.url, { email });
      setSuccess(true);
      toast.success('Password reset link sent to your email');
    } catch (err) {
      setError(err.response?.data?.message || 'Error sending reset link');
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-start min-h-screen bg-gray-50 p-4">
      {/* Logo */}
      <div className="flex justify-center mb-6 mt-5">
        <img
          src={Logo}
          alt="Naach Boutique Logo"
          className="h-64 w-64 rounded-full"
        />
      </div>
      <div className="bg-white shadow-lg rounded-xl overflow-hidden w-full max-w-md">
        <div className="p-6 md:p-8">
          <h1 className="text-2xl font-bold text-gray-800 mb-2">Forgot Password</h1>
          <p className="text-gray-600 mb-6">
            {success 
              ? 'Check your email for the password reset link'
              : 'Enter your email to receive a password reset link'}
          </p>

          {!success ? (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-1">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="your@email.com"
                  disabled={loading}
                />
                {error && <p className="text-sm text-red-500">{error}</p>}
              </div>

              <button
                type="submit"
                disabled={loading}
                className={`w-full py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors ${
                  loading ? 'opacity-70 cursor-not-allowed' : ''
                }`}
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          ) : (
            <button
              onClick={() => navigate('/login')}
              className="w-full py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            >
              Back to Login
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;